import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function MidCTASection() {
  return <section className="py-8 md:py-10 px-6 bg-cream" data-id="element-93">
      <FadeIn data-id="element-94">
        <div className="max-w-2xl mx-auto text-center" data-id="element-95">
          <p className="font-serif text-lg md:text-xl text-navy/80 mb-4 italic" data-id="element-96">
            ¿Listo para despertar diferente?
          </p>
          <CTAButton data-id="element-97">QUIERO RECUPERAR MIS MAÑANAS</CTAButton>
        </div>
      </FadeIn>
    </section>;
}